import React from "react";
import { AddPanelWhatsappGroup } from "../../../UI/Groups/Whatsapp/Add/AddPanelWhatsappGroup";

const AddWhatsappGroup = () => {
  return (
    <div>
      <AddPanelWhatsappGroup />
    </div>
  );
};

export default React.memo(AddWhatsappGroup);
